import { render, staticRenderFns } from "./customer-summary.vue?vue&type=template&id=3e6347dc&functional=true&"
import script from "./customer-summary.vue?vue&type=script&lang=js&"
export * from "./customer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports